import { knowledgeBaseApi } from '@/core/api/knowledge-base';

export const {
    useListKnowledgeBaseCollectionsQuery,
    useGetKnowledgeBaseCollectionQuery,
    useCreateKnowledgeBaseCollectionMutation,
    useUpdateKnowledgeBaseCollectionMutation,
    useDeleteKnowledgeBaseCollectionMutation,
    useReprocessKnowledgeBaseDocumentsMutation,
} = knowledgeBaseApi;